import { RouteProps } from 'react-router-dom';
import { ProtectedProps } from '../components/UserSession/Protected';
import { FC } from 'react';

type Page = RouteProps & {
  protectedProps?: ProtectedProps;
  isProtected?: boolean;
  disabled?: boolean;
  priority?: number;
  label?: string;
};

interface Route {
  default: { routeProps?: Page } & FC;
}

function getPriority(route: Route['default']) {
  return route.routeProps?.priority ?? 0;
}

export default function getRoutes(routes: Route[]) {
  return Object.values(routes)
    .map((route) => route.default)
    .filter((route) => route.routeProps && !route.routeProps?.disabled)
    .sort((a, b) => getPriority(b) - getPriority(a));
}
